<template>
    <section class="padding-vertical-content" id="paso-1">
        <div class="container">
            <div class="row" id="selectorButacas">
                <b-col cols="12" class="text-center">
                    <h2 class="h1">
                        {{ sesion.evento.name }}
                    </h2>
                    <hr/>
                </b-col>
                <b-col cols="12" style="min-height: 200px;" v-if="! zona_seleccionada">
                    <transition name="fade" mode="out-in">
                        <ContentOrLoading>
                            <SeleccionarZonaComponent
                                v-if="! cargando_zonas"
                                :pack="pack"
                                :zonas="zonas"
                                @zonaSeleccionada="zonaSeleccionada"
                                :precios_seleccionados="precios_seleccionados"
                            />
                        </ContentOrLoading>
                    </transition>
                </b-col>
                <b-col cols="12" v-else>
                    <transition name="fade" mode="out-in">
                        <SeleccionarButacasComponent
                            :zona="zona_seleccionada"
                            :pack="pack"
                            :disabled="false"
                            @terminado="bloquearAsientos"
                            :asientos_maximos="asientos_maximos"
                            :asientos_minimos="asientos_minimos"
                            :sesiones_ids="[sesion.id]"
                            :precios_seleccionados="precios_seleccionados"
                            @reset="reset"
                        />
                    </transition>
                </b-col>
            </div>
        </div>
    </section>
</template>

<script>
    import SeleccionarZonaComponent from "@/components/frontend/packs/venta/con_recinto/components/SeleccionarZonaComponent.vue";
    import SeleccionarButacasComponent from "@/components/frontend/packs/venta/con_recinto/components/SeleccionarButacasComponent.vue";

    export default {
        components: {SeleccionarZonaComponent, SeleccionarButacasComponent},
        props: {
            sesion: {
                type: Object,
                required: true
            },
            pack: {
                type: Object,
                required: true
            },
            n_asientos: {
                type: Number,
                required: false
            },
            precios_seleccionados: {
                type: Array,
                required: false
            },
            session_id: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                zonas: null,
                cargando_zonas: true,
                zona_seleccionada: null,
                loading:false,
                asientos_minimos: 1,
                asientos_maximos: 5
            }
        },
        computed: {
            footer() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        created() {
            this.getZonas();

            if(this.n_asientos) {
                this.asientos_minimos = this.n_asientos;
                this.asientos_maximos = this.n_asientos;
            }
        },
        methods: {
            getZonas() {
                const params = {
                    filters: {
                        tid : this.configuracion.hash_teatro
                    },
                    slug: this.pack.slug,
                    sesiones_ids: [this.sesion.id]
                }

                this.$store.dispatch(this.config.getVuexAlias("front.packs.show.zonas"), params).then(res => {
                    this.zonas = res.data.data;
                    this.cargando_zonas = false;
                    this.$nextTick(() => {
                        this.$scrollTo('#selectorButacas', 500);
                    });
                });
            },
            zonaSeleccionada(zona) {
                this.zona_seleccionada = zona;
            },
            bloquearAsientos(asientos) {
                this.loading = true;
                const params = {
                    filters: {
                        tid : this.configuracion.hash_teatro
                    },
                    zona_id: this.zona_seleccionada.id,
                    slug: this.pack.slug,
                    asientos: asientos,
                    sesiones_ids: [this.sesion.id],
                    session_id: this.session_id
                }

                this.$store.dispatch(this.config.getVuexAlias("front.packs.show.zonas.show.asientos.bloquear"), params).then(res => {
                    this.$emit('continuar', asientos, res.data.session_id);
                    this.loading = false;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.loading = false;
                });
            },
            reset() {
                this.zona_seleccionada = null;
            }
        },
    }
</script>